import { ConsignmentSettingUpdatePage } from "@/features/consignment-setting/pages/ConsignmentSettingUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-setting/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: ["consignment_setup.view", "consignment_setup.update"],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentSettingUpdatePage,
});
